

<template>
    <div class="canvas">
        <div class="search">
            <el-row :gutter="20" :model="params" class="search-mt">
            <el-col :span="12" class="row-col">
                <label>查询范围：</label>
                <el-select v-model="params.findScope" placeholder="全站" size="mini">
                    <el-option value="全站">全站</el-option>
                    <el-option
                        v-for="item in selectList"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="12" class="row-col">
                <label>查询方式：</label>
                <el-select
                v-model="params.findWay"
                collapse-tags
                size="mini"
                clearable
                placeholder="请选择">
                    <el-option
                        v-for="item in selectList2"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            </el-row>
            <el-row :gutter="20" :model="params" class="search-mt">          
            <el-col :span="12" class="row-col">
                <label>查询内容：</label>
                <el-input v-model="params.findContent" clearable placeholder="请输入" size="mini"></el-input>
            </el-col>
            <el-col :span="5">
                <el-button type="primary" class="btn-search" @click="goSearch" icon="el-icon-search">查询</el-button>
            </el-col>
            </el-row>
        </div>
        <XThree  :list="list" @handleDetail="jumpDocInfo" />

        <div class="page">
            <el-pagination
                small
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="params.pageIndex"
                :page-size="params.pageSize"
                :page-sizes="[10, 15, 20, 30]"
                layout="prev, pager, next, jumper"
                :pager-count="5"
                :total="total">
            </el-pagination>
        </div>

    </div>
</template>
<script>
import {
    getPortalFastSearchListApi,
    getDocBaseInfoByIdApi,
    getSearchScopeListApi
} from "@/api"
import XThree from '@/components/XThree/XThree'
export default {
    components:{
        // XSeven
        // InfoList
        XThree
    },

  data () {
    return {
      list: [1, 2, 3, 4, 5],
      params:{
          pageIndex: 1,
          pageSize: 10,
      },
      selectList:[],
      selectList2:[{id:'1', label:'正文'}, {id:'2', label:'标题'}],
      currentPage:1,
      total:0,
      activeNames: [],
    //   returnList:[],
      flag:true,
      text:[]
    }
  },
  mounted(){
    if (this.$route.query.searchInfo){
        this.params = JSON.parse(this.$route.query.searchInfo)
    }
    this.$set(this.params, 'pageIndex', 1)
    this.$set(this.params, 'pageSize', 10)
    this.searchList(this.params)
  },
  created(){
    this.getSelectScopeList()
    this.searchList()
  },
  methods: {
    async getSelectScopeList(){
        const {data} = await getSearchScopeListApi()
        if (data){
            this.selectList = data
        }
    },
    async getlist(param, flg){
            let returnList = []
            param.policiesType = flg
            const { data } = await getPoliciesAndRegulationstApi(param)
            if(data){
                this.total = data.count
                if (data.list){
                    data.list.forEach(item => {
                        let info = {
                            docId: item.doc_id,
                            title: item.policies_title,
                            content: item.policies_content,
                            showDate: item.showDate
                        }
                        returnList.push(info)
                    })
                }
                this.list = returnList
            }

        },
    /** 搜索数据列表 */
    async searchList(params,flg) {
        let returnList = []
        const { data } = await getPortalFastSearchListApi(params)
        console.log(data,'li')
        if(data){
                this.total = data.count
                if (data.list){
                    data.list.forEach(item => {
                        let info = {
                            docId: item.doc_id,
                            title: item.self_title,
                            content: item.self_content,
                            showDate: item.showDate
                        }
                        returnList.push(info)
                    })
                }
                this.list = returnList
            }
    },
    async getDocInfo(item){
        item.isActive = !item.isActive
        var docid = item.doc_id
        const { data } = await getDocBaseInfoByIdApi({
            doc_id: docid,
            pageIndex:this.pageIndex,
            pageSize:this.pageSize,
           
        })
        if (data.docBase) {
            this.text=data.docBase
            // document.getElementById(docid).innerHTML = data.docBase.doc_content
        }
    },
    jumpDocInfo(docId){
            this.$router.push({
                path: '/XInfo1',
                query: {
                    docId: docId,
                    position: '/XSearch',
                    positionName: '查询'
                }
            }, () => {})
        },
    goToDocInfo(docId){
        // this.$router.push({
        //     path: '/DocInfo',
        //     query: {
        //         docId: docId
        //     }
        // }, () => {})
    },
    replaceImg(info) {
        if (info) {
            let content
            content = info.replace(/<img .*?>/g,"");//去除图片在列表中显示
            return content
        }
    },
    goSearch(){
        this.currentPage = 1
        this.$set(this.params, 'findScope', this.params.findScope === '全站'?'':this.params.findScope)
        this.$set(this.params, 'pageIndex', 1)
        this.$set(this.params, 'pageSize', 10)
        this.searchList(this.params)
    },
    handleSizeChange(val) {
        this.$set(this.params, 'pageSize', val)
        this.searchList(this.params)
    },
    handleCurrentChange(val) {
        this.$set(this.params, 'pageIndex', val)
        this.searchList(this.params)
    },
    // goHome(){
    //     this.$router.push({
    //       path: '/home'
    //     })
    // },
    // handleChange(val){
    //     console.log(val)
    // },
  }
}
</script>

<style lang="scss" scoped>
@import './XSearch.scss';
</style>
<style lang="scss">
 .collsearch{
    width: 100%;
    float: right;
    .el-collapse{
        border: none;
        font-size: 25px;     
    }
    .el-collapse-item__header{
        border-bottom: none;
        justify-content: flex-end;
        margin: 0;
        padding: 0;
        // height: 30px;
        // background:#F0F4F7 ;
        // transform: translate(-6px,-13px);
    }
    .el-collapse-item__header.is-active{
        border-bottom-color: none;
    }
    .el-collapse-item__wrap{
        border-bottom: none;
    }
    .el-collapse-item__arrow{
        display: none;
    }
    .el-icon-circle-plus-outline::before{
        font-size: 25px;
    }
    .el-icon-remove-outline:before{
        font-size: 25px;
    }
 }
</style>